import React from 'react';

const ObjectDetectionFilterModal = ({
  handleFiltreModal,
  setStartValue, startValue,
  endValue, setEndValue,
  annotationStatus, statusValue,
  handleInputChange,
  predictionFiltreOption, predictionValue,
  actualValue,
  modelDefectLabels, SelectedModelDefect,
  handleFormSubmit,
}: any) => {
  return (
    <div className="vt-modal-bg" onClick={e => { if (e.target === e.currentTarget) handleFiltreModal(); }}>
      <div className="vt-modal">
        <div className="vt-modal-top">
          <h2>Filter Images</h2>
          <button className="vt-modal-x" onClick={handleFiltreModal}>
            <span className="material-icons-round">close</span>
          </button>
        </div>

        <div className="vt-modal-form">
          <div className="vt-form-grp">
            <label>From</label>
            <input
              type="datetime-local"
              value={startValue}
              onChange={e => setStartValue(e.target.value)}
            />
          </div>

          <div className="vt-form-grp">
            <label>To</label>
            <input
              type="datetime-local"
              value={endValue}
              onChange={e => setEndValue(e.target.value)}
            />
          </div>

          <div className="vt-form-grp">
            <label>Status</label>
            <select
              value={statusValue}
              onChange={e => handleInputChange('status', { id: e.target.value })}
            >
              {annotationStatus?.map((opt: any) => (
                <option key={opt.id} value={opt.id}>{opt.label}</option>
              ))}
            </select>
          </div>

          <div className="vt-form-grp">
            <label>Predicted</label>
            <select
              value={predictionValue}
              onChange={e => handleInputChange('predict', { id: e.target.value })}
            >
              {predictionFiltreOption?.map((opt: any) => (
                <option key={opt.id} value={opt.id}>{opt.label}</option>
              ))}
            </select>
          </div>

          {statusValue === '2' && (
            <div className="vt-form-grp">
              <label>Actual</label>
              <select
                value={actualValue}
                onChange={e => handleInputChange('actual', { id: e.target.value })}
              >
                {predictionFiltreOption?.map((opt: any) => (
                  <option key={opt.id} value={opt.id}>{opt.label}</option>
                ))}
              </select>
            </div>
          )}

          {predictionValue === '2' && (
            <div className="vt-form-grp">
              <label>Defect Type</label>
              <select
                value={SelectedModelDefect}
                onChange={e => handleInputChange('modelDefect', { id: e.target.value })}
              >
                {modelDefectLabels?.map((opt: any) => (
                  <option key={opt.id} value={opt.id}>{opt.label}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        <div className="vt-modal-foot">
          <button className="vt-mbtn vt-mbtn-ghost" onClick={handleFiltreModal}>Cancel</button>
          <button className="vt-mbtn vt-mbtn-pri" onClick={handleFormSubmit}>Apply</button>
        </div>
      </div>
    </div>
  );
};

export default ObjectDetectionFilterModal;
